import { defineMessages } from 'react-intl'

export default defineMessages({
  heading: {
    id: 'PermissionsModal.Heading',
    defaultMessage: "You're almost there!"
  },
  paragraph1: {
    id: 'PermissionsModal.Paragraph1',
    defaultMessage: 'Additional permissions are required. Please contact support'
  },
  paragraph2: {
    id: 'PermissionsModal.Paragraph2',
    defaultMessage: 'to request access and get building.'
  },
  dismiss: {
    id: 'PermissionsModal.Dismiss',
    defaultMessage: 'Dismiss'
  },
  requiredRoles: {
    id: 'PermissionsModal.RequiredRoles',
    defaultMessage: 'Required roles: {roles}'
  }
})
